// src/components/HeroSection.jsx
import React, { useState, useEffect } from 'react';
import { Download, ChevronDown, Zap, Trophy, Medal, Target, Shield } from 'lucide-react';
import {Link} from "react-router-dom"
const HeroSection = () => {
  const [rotatingPhraseIndex, setRotatingPhraseIndex] = useState(0);
  const [isRotatingTextVisible, setIsRotatingTextVisible] = useState(true);
  const [xpPoints, setXpPoints] = useState(0);

  const rotatingPhrases = ["interactive quizzes", "bite-sized lessons", "social challenges"];

  const gameIcons = [
    { icon: Trophy, position: 'top-20 right-20', rotation: '15deg', color: 'yellow-500' },
    { icon: Medal, position: 'bottom-20 left-32', rotation: '-10deg', color: 'blue-500' },
    { icon: Target, position: 'top-32 left-20', rotation: '20deg', color: 'green-500' },
    { icon: Shield, position: 'bottom-32 right-32', rotation: '-15deg', color: 'purple-500' }
  ];


  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsRotatingTextVisible(false);
      setTimeout(() => {
        setRotatingPhraseIndex((prev) => (prev + 1) % rotatingPhrases.length);
        setIsRotatingTextVisible(true);
      }, 500);
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);

  return (
      <>

        <section className="relative min-h-screen flex items-center justify-center p-4" style={{ marginTop: '3rem' }}>
          {/*<div className="absolute inset-0 overflow-hidden">*/}
          {/*  {gameIcons.map((IconObj, index) => (*/}
          {/*      <div*/}
          {/*          key={index}*/}
          {/*          className={`absolute ${IconObj.position} transform hover:scale-110 transition-transform duration-300`}*/}
          {/*          style={{*/}
          {/*            transform: `rotate(${IconObj.rotation})`,*/}
          {/*            perspective: '1000px'*/}
          {/*          }}*/}
          {/*      >*/}
          {/*        <div className="relative group animate-bounce-slow hover:scale-110 transition-transform duration-500">*/}
          {/*          <div*/}
          {/*              style={{ background: '#6A5AE0', opacity: '0.15' }}*/}
          {/*              className="absolute inset-0 rounded-3xl blur-lg group-hover:opacity-25 transition-opacity"*/}
          {/*          />*/}
          {/*          <div className="relative bg-white p-6 rounded-3xl shadow-2xl">*/}
          {/*            <IconObj.icon className={`w-12 h-12 text-${IconObj.color}`} />*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*  ))}*/}
          {/*</div>*/}

          <div className="container mx-auto text-center relative z-10 mt-20 flex flex-col gap-16">
            <div className="space-y-8">
              <h2 className="text-5xl coiny-regular leading-tight" style={{color: '#6A5AE0'}}>
                Turn Your Exam Prep<br/>
                Into A High-Score Quest—And Win!
              </h2>

              <p className="text-xl Montserrat font-bold italic leading-relaxed text-gray-600">
                Breeze through competitive exams with{' '}
                <span
                    className="inline-block min-w-[200px] transition-opacity duration-300 text-2xl mx-1 text-gray-700"
                    style={{
                      opacity: isRotatingTextVisible ? '1' : '0',
                      transform: 'translateY(0)',
                      color: '#6A5AE0'
                    }}
                >
                {rotatingPhrases[rotatingPhraseIndex]}
              </span>
                <span> that keep you on track.<br/>Let the fun begin!</span>
              </p>
            </div>


            <div className="flex justify-center gap-6 mb-16">
              <a
                  href="https://go.prepairo.ai/site-appstore"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                <button
                    style={{
                      backgroundColor: '#6A5AE0',
                      boxShadow: '0 6px 0 #4F43A8',
                      transform: 'translateY(-3px)'
                    }}
                    className="group flex items-center gap-3 text-white px-8 py-3 rounded-xl hover:translate-y-[-1px] hover:bg-opacity-90 active:translate-y-1 active:shadow-none transition-all duration-200"
                >
                  <span className="font-bold text-base">App Store</span>
                  <Download className="w-5 h-5 group-hover:animate-bounce"/>
                </button>
              </a>
              <a
                  href="https://go.prepairo.ai/site-playstore"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                <button
                    style={{
                      backgroundColor: '#6A5AE0',
                      boxShadow: '0 6px 0 #4F43A8',
                      transform: 'translateY(-3px)'
                    }}
                    className="group flex items-center gap-3 text-white px-8 py-3 rounded-xl hover:translate-y-[-1px] hover:bg-opacity-90 active:translate-y-1 active:shadow-none transition-all duration-200"
                >
                  <span className="font-bold text-base">Play Store</span>
                  <Download className="w-5 h-5 group-hover:animate-bounce"/>
                </button>
              </a>
            </div>
            <ChevronDown
                style={{color: '#6A5AE0'}}
                className="mx-auto animate-bounce w-8 h-8 opacity-60"
            />
          </div>
        </section>
      </>
  );
};

export default HeroSection;